import { machineTypeSchema } from "@packsize/schemas/machines";

export const X6_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.X6 }] as const;
